// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customSelect__wrapper .customSelect__control {

  width: 100%;

  border-radius: calc(var(--radius) - 2px);

  border-width: 1px;

  --tw-border-opacity: 1;

  border-color: rgb(226 232 240 / var(--tw-border-opacity));

  --tw-bg-opacity: 1;

  background-color: rgb(255 255 255 / var(--tw-bg-opacity));

  font-size: 0.75rem;

  line-height: 1.25;

  --tw-text-opacity: 1;

  color: rgb(26 32 44 / var(--tw-text-opacity));

  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);

  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

          box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform;

  transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform;

  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;

  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, -webkit-box-shadow, -webkit-transform;

  -webkit-transition-duration: 200ms;

          transition-duration: 200ms;

  -webkit-animation-duration: 200ms;

          animation-duration: 200ms;

  min-height: 40px;
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.customSelect__wrapper .customSelect__control:hover {

  --tw-border-opacity: 1;

  border-color: rgb(203 213 224 / var(--tw-border-opacity));
}

.customSelect__wrapper .customSelect__control--is-focused,
.customSelect__wrapper .customSelect__control--menu-is-open {

  --tw-border-opacity: 1;

  border-color: rgb(213 43 30 / var(--tw-border-opacity));

  outline: 2px solid transparent;

  outline-offset: 2px;

  -webkit-box-shadow: 0 0 0 2px rgba(213, 43, 30, 0.12);

          box-shadow: 0 0 0 2px rgba(213, 43, 30, 0.12);
}

/* Value container */

.customSelect__wrapper .customSelect__value-container {
  padding: 4px 10px !important;
}

.customSelect__wrapper .customSelect__value-container--is-multi {

  display: inline-block;

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap;

  padding: 4px 10px !important;
}

/* Search input */

.customSelect__wrapper .customSelect__input {

  --tw-text-opacity: 1 !important;

  color: rgb(26 32 44 / var(--tw-text-opacity)) !important;

  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}

.customSelect__wrapper .customSelect__input-container {
  margin: 0;
}

/* Placeholder */

.customSelect__wrapper .customSelect__placeholder {

  --tw-text-opacity: 1;

  color: rgb(203 213 224 / var(--tw-text-opacity));

  margin-left: 2px;
}

/* Selected single value */

.customSelect__wrapper .customSelect__single-value {

  --tw-text-opacity: 1;

  color: rgb(26 32 44 / var(--tw-text-opacity));

  max-width: calc(100% - 20px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Dropdown indicator */

.customSelect__wrapper .customSelect__indicator-separator {
  display: none;
}

.customSelect__wrapper .customSelect__dropdown-indicator {
  padding: 6px 8px;
  color: #6b7280;
}

.customSelect__wrapper .customSelect__dropdown-indicator:hover {
  color: #d52b1e;
}

/* Disabled */

.customSelect__wrapper.customSelect--is-disabled {

  cursor: not-allowed;
}

.customSelect__wrapper .customSelect__control--is-disabled {

  cursor: not-allowed;

  --tw-border-opacity: 1;

  border-color: rgb(237 242 247 / var(--tw-border-opacity));

  --tw-bg-opacity: 1;

  background-color: rgb(247 250 252 / var(--tw-bg-opacity));

  opacity: 0.75;
}

/* Dropdown */

.customSelect__menu-portal .customSelect__menu {
  margin-top: 4px;
  overflow: hidden;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: #ffffff !important;
  -webkit-box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.customSelect__menu-portal .customSelect__menu-list {
  overflow-x: hidden !important;
  padding: 4px !important;
}

/* Dropdown options */

.customSelect__option {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-align: center !important;
      -ms-flex-align: center !important;
          align-items: center !important;

  min-height: 38px;
  padding: 8px 12px !important;

  border-radius: 4px;

  color: #1f2937 !important;
  background-color: #ffffff !important;

  font-size: 14px !important;

  cursor: pointer;
}

.customSelect__option--is-focused {
  background-color: #fef2f2 !important;
  color: #991b1b !important;
}

.customSelect__menu-portal .customSelect__option:hover {
  background-color: #fef2f2 !important;
  color: #991b1b !important;
}

.customSelect__option--is-selected {
  background-color: #ffffff !important;
  color: #1f2937 !important;
}

/* Multi-select selected values */

.customSelect__wrapper .customSelect__multi-value {
  margin: 2px 4px 2px 0;

  border-radius: 4px;

  background-color: #fef2f2;
}

.customSelect__wrapper .customSelect__multi-value__label {
  padding: 3px 6px;

  color: #991b1b;

  font-size: 12px;
}

.customSelect__wrapper .customSelect__multi-value__remove {
  display: none;
}

/* Dropdown scrollbar */

.customSelect__menu-portal .customSelect__menu-list::-webkit-scrollbar {
  width: 6px;
}

.customSelect__menu-portal .customSelect__menu-list::-webkit-scrollbar-track {
  background: transparent;
}

.customSelect__menu-portal .customSelect__menu-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #d1d5db;
}

.customSelect__menu-portal .customSelect__menu-list::-webkit-scrollbar-thumb:hover {
  background-color: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/Select/Select.css"],"names":[],"mappings":"AACE;;EAAA,WAA8H;;EAA9H,wCAA8H;;EAA9H,iBAA8H;;EAA9H,sBAA8H;;EAA9H,yDAA8H;;EAA9H,kBAA8H;;EAA9H,yDAA8H;;EAA9H,kBAA8H;;EAA9H,iBAA8H;;EAA9H,oBAA8H;;EAA9H,6CAA8H;;EAA9H,4CAA8H;;EAA9H,uDAA8H;;EAA9H,+GAA8H;;UAA9H,uGAA8H;;EAA9H,gIAA8H;;EAA9H,wHAA8H;;EAA9H,wGAA8H;;EAA9H,+IAA8H;;EAA9H,kCAA8H;;UAA9H,0BAA8H;;EAA9H,iCAA8H;;UAA9H,yBAA8H;;EAE9H,gBAAgB;EAChB,iDAAyC;UAAzC;AAH8H;;AAO9H;;EAAA,sBAAsB;;EAAtB;AAAsB;;AAKtB;;;EAAA,sBAAoC;;EAApC,uDAAoC;;EAApC,8BAAoC;;EAApC,mBAAoC;;EAEpC,qDAA6C;;UAA7C;AAFoC;;AAKtC,oBAAoB;;AAEpB;EACE,4BAA4B;AAC9B;;AAGE;;EAAA,qBAA4B;;EAA5B,gBAA4B;;EAA5B,uBAA4B;;EAA5B,mBAA4B;;EAE5B;AAF4B;;AAK9B,iBAAiB;;AAGf;;EAAA,+BAA+B;;EAA/B,wDAA+B;;EAE/B,8BAA8B;EAC9B;AAH+B;;AAMjC;EACE,SAAS;AACX;;AAEA,gBAAgB;;AAGd;;EAAA,oBAAoB;;EAApB,gDAAoB;;EAEpB;AAFoB;;AAKtB,0BAA0B;;AAGxB;;EAAA,oBAAoB;;EAApB,6CAAoB;;EAEpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB;AALoB;;AAQtB,uBAAuB;;AAEvB;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;;AAGX;;EAAA;AAAyB;;AAIzB;;EAAA,mBAAqD;;EAArD,sBAAqD;;EAArD,yDAAqD;;EAArD,kBAAqD;;EAArD,yDAAqD;;EAErD;AAFqD;;AAKvD,aAAa;;AAEb;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,kDAA0C;UAA1C,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA,qBAAqB;;AAErB;EACE,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,oCAA8B;MAA9B,iCAA8B;UAA9B,8BAA8B;;EAE9B,gBAAgB;EAChB,4BAA4B;;EAE5B,kBAAkB;;EAElB,yBAAyB;EACzB,oCAAoC;;EAEpC,0BAA0B;;EAE1B,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,iCAAiC;;AAEjC;EACE,qBAAqB;;EAErB,kBAAkB;;EAElB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;;EAEhB,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;;AAEvB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".customSelect__wrapper .customSelect__control {\n  @apply w-full rounded-md border border-gray-300 bg-white text-sm leading-tight text-gray-900 shadow-sm transition duration-200;\n\n  min-height: 40px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.customSelect__wrapper .customSelect__control:hover {\n  @apply border-gray-400;\n}\n\n.customSelect__wrapper .customSelect__control--is-focused,\n.customSelect__wrapper .customSelect__control--menu-is-open {\n  @apply border-[#d52b1e] outline-none;\n\n  box-shadow: 0 0 0 2px rgba(213, 43, 30, 0.12);\n}\n\n/* Value container */\n\n.customSelect__wrapper .customSelect__value-container {\n  padding: 4px 10px !important;\n}\n\n.customSelect__wrapper .customSelect__value-container--is-multi {\n  @apply inline-block truncate;\n\n  padding: 4px 10px !important;\n}\n\n/* Search input */\n\n.customSelect__wrapper .customSelect__input {\n  @apply text-gray-900 !important;\n\n  font-size: 0.875rem !important;\n  line-height: 1.25rem !important;\n}\n\n.customSelect__wrapper .customSelect__input-container {\n  margin: 0;\n}\n\n/* Placeholder */\n\n.customSelect__wrapper .customSelect__placeholder {\n  @apply text-gray-400;\n\n  margin-left: 2px;\n}\n\n/* Selected single value */\n\n.customSelect__wrapper .customSelect__single-value {\n  @apply text-gray-900;\n\n  max-width: calc(100% - 20px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Dropdown indicator */\n\n.customSelect__wrapper .customSelect__indicator-separator {\n  display: none;\n}\n\n.customSelect__wrapper .customSelect__dropdown-indicator {\n  padding: 6px 8px;\n  color: #6b7280;\n}\n\n.customSelect__wrapper .customSelect__dropdown-indicator:hover {\n  color: #d52b1e;\n}\n\n/* Disabled */\n\n.customSelect__wrapper.customSelect--is-disabled {\n  @apply cursor-not-allowed;\n}\n\n.customSelect__wrapper .customSelect__control--is-disabled {\n  @apply cursor-not-allowed border-gray-200 bg-gray-100;\n\n  opacity: 0.75;\n}\n\n/* Dropdown */\n\n.customSelect__menu-portal .customSelect__menu {\n  margin-top: 4px;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background-color: #ffffff !important;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);\n}\n\n.customSelect__menu-portal .customSelect__menu-list {\n  overflow-x: hidden !important;\n  padding: 4px !important;\n}\n\n/* Dropdown options */\n\n.customSelect__option {\n  display: flex !important;\n  align-items: center !important;\n\n  min-height: 38px;\n  padding: 8px 12px !important;\n\n  border-radius: 4px;\n\n  color: #1f2937 !important;\n  background-color: #ffffff !important;\n\n  font-size: 14px !important;\n\n  cursor: pointer;\n}\n\n.customSelect__option--is-focused {\n  background-color: #fef2f2 !important;\n  color: #991b1b !important;\n}\n\n.customSelect__menu-portal .customSelect__option:hover {\n  background-color: #fef2f2 !important;\n  color: #991b1b !important;\n}\n\n.customSelect__option--is-selected {\n  background-color: #ffffff !important;\n  color: #1f2937 !important;\n}\n\n/* Multi-select selected values */\n\n.customSelect__wrapper .customSelect__multi-value {\n  margin: 2px 4px 2px 0;\n\n  border-radius: 4px;\n\n  background-color: #fef2f2;\n}\n\n.customSelect__wrapper .customSelect__multi-value__label {\n  padding: 3px 6px;\n\n  color: #991b1b;\n\n  font-size: 12px;\n}\n\n.customSelect__wrapper .customSelect__multi-value__remove {\n  display: none;\n}\n\n/* Dropdown scrollbar */\n\n.customSelect__menu-portal .customSelect__menu-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.customSelect__menu-portal .customSelect__menu-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.customSelect__menu-portal .customSelect__menu-list::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: #d1d5db;\n}\n\n.customSelect__menu-portal .customSelect__menu-list::-webkit-scrollbar-thumb:hover {\n  background-color: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
